<li class="action-plan-topic {{#if active}}active{{/if}} {{#if done}}done{{/if}}" {{#if active}}tabindex="0"{{/if}} data-id="{{id}}">
  <div class="heading"></div>
  <h4>{{t 'actionPlan.subheader'}}</h4>
  <span class="name">{{name}}</span>

  {{#if anyActionPlanItems}}
    <div class="steps-description">
      <p>{{stepsComplete}}</p>
    </div>
    <ul class="action-plan-items">
      {{#each action_plan_items_collection}}
        <li class="action-plan-item" data-id="{{id}}" {{#if active}}tabindex="0"{{/if}}>
          <span class="title">{{{title}}}</span>
          <div class="marked-down">{{m body}}</div>
          {{#if other}}
            <textarea class="action-plan-item-response-other" {{#if actionPlanItemResponse}}disabled{{/if}} >{{actionPlanItemResponse.other_response}}</textarea>
          {{/if}}

          <div class="response-buttons" data-id="{{actionPlanItemResponse.id}}">
            <a href="#" role="button" class="btn {{#if actionPlanItemResponse}}disabled{{/if}}" {{#if actionPlanItemResponse}}tabindex="-1"{{/if}} data-state="now">{{t 'actionPlanResponses.now'}}</a>
            <a href="#" role="button" class="btn {{#if actionPlanItemResponse}}disabled{{/if}}" {{#if actionPlanItemResponse}}tabindex="-1"{{/if}} data-state="later">{{t 'actionPlanResponses.later'}}</a>
          </div>

        </li>
      {{/each}}
    </ul>
  {{/if}}

</li>
